const symbols = new Map<string, string>();

/**
 * The symbol a locale uses for a currency, e.g. `€` for EUR or `$` for USD.
 *
 * @returns the symbol, or the currency code itself when the runtime has none
 */
export function currencySymbol(currency: string, locale: string): string {
    const key = `${locale}|${currency}`;

    let symbol = symbols.get(key);
    if (symbol !== undefined) {
        return symbol;
    }

    try {
        const part = new Intl.NumberFormat(locale, { style: 'currency', currency })
            .formatToParts(0)
            .find((candidate) => candidate.type === 'currency');

        symbol = part?.value || currency;
    } catch {
        symbol = currency;
    }

    symbols.set(key, symbol);

    return symbol;
}

export default currencySymbol;
